import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';

import UserAvatar from 'components/UserAvatar';

import useDialog from 'hooks/useDialog';
import useMediaQuery from 'hooks/useMediaQuery';

import { sendEvent } from 'lib/gtag';

const LoginDialog = dynamic(() => import('components/LoginDialog'), {
  ssr: false,
});

const SignUpButton = ({ gaEventCategory, ...rest }) => {
  const { showDialog } = useDialog();
  const { isLg } = useMediaQuery();

  const onSignUpButtonClickHandler = () => {
    sendEvent({
      action: isLg ? 'topbar_login' : 'topbar_login_webmobile',
      category: gaEventCategory,
    });

    showDialog(LoginDialog);
  };

  return (
    <button
      aria-label="Abrir modal de cadastro"
      className="relative size-10"
      data-test-selector="open-signup-modal"
      onClick={onSignUpButtonClickHandler}
      {...rest}
    >
      <UserAvatar description="Usuário deslogado" size="size5" />
    </button>
  );
};

SignUpButton.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
};

export default SignUpButton;
